/* eslint-disable max-lines */
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import {
  CheckBoxField,
  DatePickerField,
  DisplayOptions,
  DynamicTextListField,
  MultiLineTextField,
  RadioOptionsField,
  TextField,
} from "../../../components";
import { CustomCheckBoxField } from "../../../components/CustomCheckBoxField/CustomCheckBoxField";
import { CustomMultiLineTextField } from "../../../components/CustomMultiLineTextField/CustomMultiLineTextField";
import { CustomRadioOptionsField } from "../../../components/CustomRadioOptionsFIeld.tsx/CustomRadioOptionsField";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import { EngineNames, PlatformNames } from "../../../constants";
import {
  pitchAboutYourGameInitialValues,
  pitchInputsMaxLength,
  usePitchInformationAboutYourGameValidationSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import {
  BusinessModelOptions,
  ContainsNftOrBlockchainOptions,
  DevelopmentStageOptions,
  GameEngineOptions,
  GenreOptions,
  HasTheGameBeenAnnouncedOptions,
  OnlineMultiplayerOptions,
  ReleasedForOtherPlatformsOptions,
  ReleasedPlatformsOptions,
  SensitiveContentOptions,
  TargetedPlatformsOptions,
} from "../../../models/pitchUxModels";
import { getIsSavingForm } from "../../../redux/selectors";
import {
  PitchInformationFormId,
  PitchInformationSubFormsId,
} from "../PitchInformationPageConstants";
import * as styles from "../PublisherDeveloperSubForm/PublisherDeveloperSubForm.module.css";

const AboutYourGameSubForm = (props: SubFormNavigationProps) => {
  const [
    pitchAboutYourGameGameTitleTitle,
    pitchAboutYourGameContainsNftOrBlockchainTitle,
    yes,
    no,
    unknownString,
    gameConcept,
    prototype,
    alpha,
    beta,
    closedBeta,
    openBeta,
    readyToLaunch,
    earlyAccess,
    launched,
    pitchAboutYourGameStageOfDevelopmentTitle,
    pitchAboutYourGameHasTheGameBeenLaunchedTitle,
    pitchAboutYourGameHasTheGameBeenLaunchedSubtitle,
    pitchAboutReleasedPlatformsTitle,
    pitchAboutReleasedPlatformsSubtitle,
    pitchAboutYourGameContainsReleasedPlatformsDateTitle,
    other,
    pitchAboutYourGameTargetedPlatformsTitle,
    pitchAboutYourGameHasTheGameBeenAnnouncedTitle,
    pitchAboutYourGameHasTheGameBeenAnnouncedSubtitle,
    action,
    adventure,
    arcade,
    battleRoyale,
    firstPersonThirdPersonShooter,
    moba,
    narrativeStory,
    mmorpg,
    rolePlayingGame,
    sandbox,
    simulation,
    survivalHorror,
    pitchAboutYourGameWhichGameGenreFitsYourGameBestTitle,
    pitchAboutYourGameWhichGameEngineTitle,
    premium,
    premiumPaidDLC,
    premiumFreeDLC,
    gamesAsAService,
    freeToPlay,
    pitchAboutYourGameBusinessModelTitle,
    pitchAboutYourGameGameplayDurationTitle,
    pitchAboutYourGameOnlineMultiplayerTitle,
    pitchAboutYourGameLinkGameIntroductionDeckTitle,
    pitchAboutYourGameLinkOtherAssetsTitle,
    pitchAboutYourGameLinkOtherAssetsSubtitle,
    addLink,
    pitchAboutYourGameBuildLinksTitle,
    pitchAboutYourGameVideoLinksTitle,
    pitchAboutYourGameGameDescriptionTitle,
    pitchAboutYourGameTargetAudienceTitle,
    pitchAboutYourGameCompetitorTitlesTitle,
    pitchAboutYourGameUniqueFactorTitle,
    pitchAboutYourGameFeelingsEvokedTitle,
    pitchAboutYourGamePivotalMomentTitle,
    pitchAboutYourGamePostLaunchSupportPlansTitle,
    maybe,
    pitchAboutYourGameSensitiveContentTitle,
    pitchAboutYourGameSensitiveContentSubtitle,
    pitchAboutYourGameSensitiveContentDetailsTitle,
    pitchAboutYourGameXboxReleaseWindowTitle,
    pitchAboutYourGameXboxReleaseWindowSubtitle,
    pitchAboutYourGameSteamReleaseWindowTitle,
    pitchAboutYourGameSteamReleaseWindowSubtitle,
    examplelink,
  ] = useStrings(
    "pitchAboutYourGameGameTitleTitle",
    "pitchAboutYourGameContainsNftOrBlockchainTitle",
    "yes",
    "no",
    "unknownString",
    "gameConcept",
    "prototype",
    "alpha",
    "beta",
    "closedBeta",
    "openBeta",
    "readyToLaunch",
    "earlyAccess",
    "launched",
    "pitchAboutYourGameStageOfDevelopmentTitle",
    "pitchAboutYourGameHasTheGameBeenLaunchedTitle",
    "pitchAboutYourGameHasTheGameBeenLaunchedSubtitle",
    "pitchAboutReleasedPlatformsTitle",
    "pitchAboutReleasedPlatformsSubtitle",
    "pitchAboutYourGameContainsReleasedPlatformsDateTitle",
    "other",
    "pitchAboutYourGameTargetedPlatformsTitle",
    "pitchAboutYourGameHasTheGameBeenAnnouncedTitle",
    "pitchAboutYourGameHasTheGameBeenAnnouncedSubtitle",
    "action",
    "adventure",
    "arcade",
    "battleRoyale",
    "firstPersonThirdPersonShooter",
    "moba",
    "narrativeStory",
    "mmorpg",
    "rolePlayingGame",
    "sandbox",
    "simulation",
    "survivalHorror",
    "pitchAboutYourGameWhichGameGenreFitsYourGameBestTitle",
    "pitchAboutYourGameWhichGameEngineTitle",
    "premium",
    "premiumPaidDLC",
    "premiumFreeDLC",
    "gamesAsAService",
    "freeToPlay",
    "pitchAboutYourGameBusinessModelTitle",
    "pitchAboutYourGameGameplayDurationTitle",
    "pitchAboutYourGameOnlineMultiplayerTitle",
    "pitchAboutYourGameLinkGameIntroductionDeckTitle",
    "pitchAboutYourGameLinkOtherAssetsTitle",
    "pitchAboutYourGameLinkOtherAssetsSubtitle",
    "addLink",
    "pitchAboutYourGameBuildLinksTitle",
    "pitchAboutYourGameVideoLinksTitle",
    "pitchAboutYourGameGameDescriptionTitle",
    "pitchAboutYourGameTargetAudienceTitle",
    "pitchAboutYourGameCompetitorTitlesTitle",
    "pitchAboutYourGameUniqueFactorTitle",
    "pitchAboutYourGameFeelingsEvokedTitle",
    "pitchAboutYourGamePivotalMomentTitle",
    "pitchAboutYourGamePostLaunchSupportPlansTitle",
    "maybe",
    "pitchAboutYourGameSensitiveContentTitle",
    "pitchAboutYourGameSensitiveContentSubtitle",
    "pitchAboutYourGameSensitiveContentDetailsTitle",
    "pitchAboutYourGameXboxReleaseWindowTitle",
    "pitchAboutYourGameXboxReleaseWindowSubtitle",
    "pitchAboutYourGameSteamReleaseWindowTitle",
    "pitchAboutYourGameSteamReleaseWindowSubtitle",
    "examplelink"
  );

  const validationSchema = usePitchInformationAboutYourGameValidationSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);
  const [hasTheGameBeenLaunchedFlag, setHasTheGameBeenLaunchedFlag] = useState<boolean | undefined>(
    undefined
  );
  const [hasSensitiveContent, setHasSensitiveContent] = useState<boolean | undefined>(undefined);
  const [isGenreOtherChecked, setIsGenreOtherChecked] = useState<boolean | undefined>(undefined);
  const [isReleasedPlatformOtherChecked, setIsReleasedPlatformOtherChecked] = useState<
    boolean | undefined
  >(undefined);

  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={pitchAboutYourGameInitialValues}
      formId={PitchInformationFormId}
      subFormId={PitchInformationSubFormsId.AboutYourGame}
      {...props}
    >
      <Row className={styles.container}>
        <Column>
          <TextField
            name="gameTitle"
            title={pitchAboutYourGameGameTitleTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <RadioOptionsField
            options={[
              {
                value: ContainsNftOrBlockchainOptions.Yes,
                label: yes,
              },
              {
                value: ContainsNftOrBlockchainOptions.No,
                label: no,
              },
              {
                value: ContainsNftOrBlockchainOptions.Unknown,
                label: unknownString,
              },
            ]}
            listAsColumn
            name="containsNftOrBlockchain"
            title={pitchAboutYourGameContainsNftOrBlockchainTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
          />
          <RadioOptionsField
            options={[
              {
                value: DevelopmentStageOptions.GameConcept,
                label: gameConcept,
              },
              {
                value: DevelopmentStageOptions.Prototype,
                label: prototype,
              },
              {
                value: DevelopmentStageOptions.Alpha,
                label: alpha,
              },
              {
                value: DevelopmentStageOptions.Beta,
                label: beta,
              },
              {
                value: DevelopmentStageOptions.ClosedBeta,
                label: closedBeta,
              },
              {
                value: DevelopmentStageOptions.OpenBeta,
                label: openBeta,
              },
              {
                value: DevelopmentStageOptions.ReadyToLaunch,
                label: readyToLaunch,
              },
              {
                value: DevelopmentStageOptions.EarlyAccess,
                label: earlyAccess,
              },
              {
                value: DevelopmentStageOptions.Launched,
                label: launched,
              },
            ]}
            listAsColumn
            name="stageOfDevelopment"
            title={pitchAboutYourGameStageOfDevelopmentTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
          />
          <RadioOptionsField
            options={[
              {
                value: ReleasedForOtherPlatformsOptions.Yes,
                label: yes,
              },
              {
                value: ReleasedForOtherPlatformsOptions.No,
                label: no,
              },
            ]}
            listAsColumn
            name={"releasedForOtherPlatforms"}
            title={pitchAboutYourGameHasTheGameBeenLaunchedTitle}
            subtitle={pitchAboutYourGameHasTheGameBeenLaunchedSubtitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            setChildInputForm={setHasTheGameBeenLaunchedFlag}
          />
          <CustomCheckBoxField
            checkBoxes={[
              {
                value: ReleasedPlatformsOptions.Sony,
                label: PlatformNames.SonyPlaystation,
              },
              {
                value: ReleasedPlatformsOptions.Steam,
                label: PlatformNames.Steam,
              },
              {
                value: ReleasedPlatformsOptions.NintendoSwitch,
                label: PlatformNames.NintendoSwitch,
              },
              {
                value: ReleasedPlatformsOptions.EpicStore,
                label: PlatformNames.EpicStore,
              },
              {
                value: ReleasedPlatformsOptions.Other,
                label: other,
              },
            ]}
            name="releasedPlatforms"
            title={pitchAboutReleasedPlatformsTitle}
            subtitle={pitchAboutReleasedPlatformsSubtitle}
            isSaving={isSavingFormToCrm}
            isRequiredField={hasTheGameBeenLaunchedFlag}
            parentChecked={hasTheGameBeenLaunchedFlag}
            isOtherChecked={isReleasedPlatformOtherChecked}
            setChildInputForm={setIsReleasedPlatformOtherChecked}
            display={DisplayOptions.column}
          />
          <DatePickerField
            isSaving={isSavingFormToCrm}
            name="releasedPlatformsDate"
            title={pitchAboutYourGameContainsReleasedPlatformsDateTitle}
            parentChecked={hasTheGameBeenLaunchedFlag}
          />
          <RadioOptionsField
            options={[
              {
                value: HasTheGameBeenAnnouncedOptions.Yes,
                label: yes,
              },
              {
                value: HasTheGameBeenAnnouncedOptions.No,
                label: no,
              },
            ]}
            listAsColumn
            name={"announced"}
            title={pitchAboutYourGameHasTheGameBeenAnnouncedTitle}
            subtitle={pitchAboutYourGameHasTheGameBeenAnnouncedSubtitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
          />
          <CheckBoxField
            checkBoxes={[
              {
                value: TargetedPlatformsOptions.SonyPlaystation,
                label: PlatformNames.SonyPlaystation,
              },
              {
                value: TargetedPlatformsOptions.Steam,
                label: PlatformNames.Steam,
              },
              {
                value: TargetedPlatformsOptions.NintendoSwitch,
                label: PlatformNames.NintendoSwitch,
              },
              {
                value: TargetedPlatformsOptions.EpicStore,
                label: PlatformNames.EpicStore,
              },
              {
                value: TargetedPlatformsOptions.Other,
                label: other,
              },
            ]}
            name={"targetedPlatforms"}
            title={pitchAboutYourGameTargetedPlatformsTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            display={DisplayOptions.column}
          />
          <DatePickerField
            isSaving={isSavingFormToCrm}
            name="steamReleaseWindow"
            title={pitchAboutYourGameSteamReleaseWindowTitle}
            subtitle={pitchAboutYourGameSteamReleaseWindowSubtitle}
          />
          <DatePickerField
            isSaving={isSavingFormToCrm}
            name="xboxReleaseWindow"
            title={pitchAboutYourGameXboxReleaseWindowTitle}
            subtitle={pitchAboutYourGameXboxReleaseWindowSubtitle}
          />
          <CustomCheckBoxField
            checkBoxes={[
              {
                value: GenreOptions.Action,
                label: action,
              },
              {
                value: GenreOptions.Adventure,
                label: adventure,
              },
              {
                value: GenreOptions.Arcade,
                label: arcade,
              },
              {
                value: GenreOptions.BattleRoyale,
                label: battleRoyale,
              },
              {
                value: GenreOptions.FirstPersonThirdPersonShooter,
                label: firstPersonThirdPersonShooter,
              },
              {
                value: GenreOptions.MMORPG,
                label: mmorpg,
              },
              {
                value: GenreOptions.MOBA,
                label: moba,
              },
              {
                value: GenreOptions.NarrativeStory,
                label: narrativeStory,
              },
              {
                value: GenreOptions.RolePlayingGame,
                label: rolePlayingGame,
              },
              {
                value: GenreOptions.Sandbox,
                label: sandbox,
              },
              {
                value: GenreOptions.Simulation,
                label: simulation,
              },
              {
                value: GenreOptions.SurvivalHorror,
                label: survivalHorror,
              },
              {
                value: GenreOptions.Other,
                label: other,
              },
            ]}
            name={"genre"}
            title={pitchAboutYourGameWhichGameGenreFitsYourGameBestTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            setChildInputForm={setIsGenreOtherChecked}
            isOtherChecked={isGenreOtherChecked}
            display={DisplayOptions.column}
          />
          <CustomRadioOptionsField
            options={[
              {
                value: GameEngineOptions.Unity,
                label: EngineNames.Unity,
              },
              {
                value: GameEngineOptions.UnrealEngine,
                label: EngineNames.UnrealEngine,
              },
              {
                value: GameEngineOptions.Godot,
                label: EngineNames.Godot,
              },
              {
                value: GameEngineOptions.Other,
                label: other,
              },
            ]}
            listAsColumn
            name={"gameEngine"}
            title={pitchAboutYourGameWhichGameEngineTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
          />
          <CheckBoxField
            checkBoxes={[
              {
                value: BusinessModelOptions.Premium,
                label: premium,
              },
              {
                value: BusinessModelOptions.PremiumPaidDLC,
                label: premiumPaidDLC,
              },
              {
                value: BusinessModelOptions.PremiumFreeDLC,
                label: premiumFreeDLC,
              },
              {
                value: BusinessModelOptions.FreeToPlay,
                label: freeToPlay,
              },
              {
                value: BusinessModelOptions.GamesAsAService,
                label: gamesAsAService,
              },
              {
                value: BusinessModelOptions.Other,
                label: other,
              },
            ]}
            name={"businessModel"}
            title={pitchAboutYourGameBusinessModelTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            display={DisplayOptions.column}
          />
          <TextField
            name="gameplayDuration"
            title={pitchAboutYourGameGameplayDurationTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <RadioOptionsField
            options={[
              {
                value: OnlineMultiplayerOptions.Yes,
                label: yes,
              },
              {
                value: OnlineMultiplayerOptions.No,
                label: no,
              },
            ]}
            listAsColumn
            name={"onlineMultiplayer"}
            title={pitchAboutYourGameOnlineMultiplayerTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
          />
          <TextField
            title={pitchAboutYourGameLinkGameIntroductionDeckTitle}
            name="gameIntroDeckLink"
            isRequiredField={true}
            isSaving={isSavingFormToCrm}
            placeholder={examplelink}
          />
          <div className={styles.dynamicContainer}>
            <DynamicTextListField
              title={pitchAboutYourGameLinkOtherAssetsTitle}
              subtitle={pitchAboutYourGameLinkOtherAssetsSubtitle}
              name="otherInfoLinks"
              buttonLabel={addLink}
              isSaving={isSavingFormToCrm}
              placeholder={examplelink}
            />
          </div>
          <TextField
            name="buildLinks"
            title={pitchAboutYourGameBuildLinksTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="videoLinks"
            title={pitchAboutYourGameVideoLinksTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="gameDescription"
            title={pitchAboutYourGameGameDescriptionTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="targetAudience"
            title={pitchAboutYourGameTargetAudienceTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="competitorTitles"
            title={pitchAboutYourGameCompetitorTitlesTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="uniqueFactor"
            title={pitchAboutYourGameUniqueFactorTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="feelingsEvoked"
            title={pitchAboutYourGameFeelingsEvokedTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="pivotalMoment"
            title={pitchAboutYourGamePivotalMomentTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="postLaunchSupportPlans"
            title={pitchAboutYourGamePostLaunchSupportPlansTitle}
            isRequiredField
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <RadioOptionsField
            options={[
              {
                value: SensitiveContentOptions.Yes,
                label: yes,
              },
              {
                value: SensitiveContentOptions.No,
                label: no,
              },
              {
                value: SensitiveContentOptions.Maybe,
                label: maybe,
              },
              {
                value: SensitiveContentOptions.Other,
                label: other,
              },
            ]}
            listAsColumn
            name={"sensitiveContent"}
            title={pitchAboutYourGameSensitiveContentTitle}
            subtitle={pitchAboutYourGameSensitiveContentSubtitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            setChildInputForm={setHasSensitiveContent}
          />
          <CustomMultiLineTextField
            name="sensitiveContentDetails"
            title={pitchAboutYourGameSensitiveContentDetailsTitle}
            isRequiredField={hasSensitiveContent}
            isSaving={isSavingFormToCrm}
            parentChecked={hasSensitiveContent}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
        </Column>
      </Row>
    </SubForm>
  );
};

export default AboutYourGameSubForm;
